import React from "react";
import { observer } from "mobx-react";
import { Carousel, Icon, Card } from "antd";
import SystemSet from "./systemSet";
import WeaMessageCenterStore from "../stores/index";
import WeaLocaleProvider from "../../../ecology9/wea-locale-provider";
import { escape2Html } from "../util";
import * as API from "../apis/index";
import "../style/index.less";
import { WeaTools } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;
const { desensitization, encryption, Encry } = WeaTools.EncryBase;
@observer
class ItemTitle extends React.PureComponent {
  onAItemClick = e =>
    this.props.onAItemClick(e, this.props.item, this.props.index);
  render() {
    const { item } = this.props;
    return (
      <div className="title">
        {desensitization(item.title) || encryption(item.title) ? (
          <Encry
            valueProps={{
              onClick: this.onAItemClick
            }}
            value={`<a target="_blank">${item.title}</a>`}
          />
        ) : (
          <a
            target="_blank"
            onClick={this.onAItemClick}
            dangerouslySetInnerHTML={{
              __html:
                item.title && item.title.length < 70
                  ? escape2Html(item.title)
                  : escape2Html(item.title).substring(0, 70) + "..."
            }}
          />
        )}
      </div>
    );
  }
}

@observer
export default class FixedPop extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      visible: false,
      list: [],
      maxtime: 0,
      systemSetVisiable: false,
      msgid: "",
      syncComponent: () => ""
    };
    this.timer = null;
    this.count = 0;
    this.autoCloseTimer = null;
  }

  componentDidMount() {
    this.getPopMessage();
    this.timer = setInterval(() => {
      this.getPopMessage();
    }, this.props.intervalTime);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.intervalTime !== this.props.intervalTime) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getPopMessage();
      }, nextProps.intervalTime);
    }
    if (
      nextProps.visible !== undefined &&
      nextProps.visible !== this.state.visible
    ) {
      this.setState({ visible: nextProps.visible });
    }
  }

  getPopMessage = () => {
    if (window._message_center) {
      if (window._message_center.open) {
        return;
      }
    }
    this.count++;
    API.getPopList({ maxtime: this.state.maxtime }).then(res => {
      const result = {
        data: [
          {
            msgid: Math.random()
              .toString(36)
              .substr(2),
            name:
              Math.random()
                .toString(36)
                .substr(2) +
              ": " +
              this.count,
            link: "//www.baidu.com",
            title: "百度",
            context:
              "<img src='https://picsum.photos/960/300' />asdfsdf</br>sadfasdf"
          },
          {
            gomethodpc: "01c5315a",
            name: Math.random()
              .toString(36)
              .substr(2),
            link: "//www.tianqi.com",
            title: "天气",
            context:
              "标题必填必填必填必填吧</br>标题必填必填必填必填吧</br>标题必填必填必填必填吧</br>阿士大夫撒打发斯蒂芬</br>asdfasdfsdf"
          }
        ]
      };
      // res = result;
      if (res && res.data.length > 0) {
        const popContainer = $(`#pop-close-${this.props.id}`);
        popContainer.show();
        if ($(`#dialogMode-message-center-${this.props.id}`).length) {
          popContainer.find(".more-link").show();
        } else {
          popContainer.find(".more-link").hide();
        }

        // let msgidArr = [];
        // if (this.state.msgid !== "") {
        //   msgidArr = this.state.msgid.split(",");
        // }
        // msgidArr.push(res.msgid);
        clearInterval(this.autoCloseTimer);
        this.setState(
          {
            visible: true,
            // msgid: msgidArr.join(),
            maxtime: res.maxtime
          },
          function() {
            this.autoCloseTimer = setTimeout(() => {
              this.setState({
                visible: false
              });
            }, this.props.autoCloseTime);
          }
        );
        this.mixHistoryMessage(res);
      } else {
        // this.setState({ list: result });
      }
    });
  };

  mixHistoryMessage = res => {
    // console.log('res', res.data.map(item => item.name));
    const currentList = this.state.list;
    const resList = res.data;
    const newList = [...currentList.reverse(), ...resList];
    if (newList.length > 5) {
      const exceedLength = newList.length - 5;
      newList.splice(0, exceedLength);
    }
    newList.reverse();

    this.setState({
      list: newList
    });
  };

  clickTitle = (index, item) => {
    if (!item.link && !item.gomethodpc) {
      return false;
    }

    if (item.gomethodpc) {
      const self = this;
      eventRegister.loadModule("f_smallApp", {}, function() {
        window.weaSmallApp.store.smsRadioStore.showMsgDialog(item.gomethodpc);
        self.setState({
          syncComponent: window.weaSmallApp.com.RadioDialog
        });
      });
    } else if (item.link) {
      window.open(item.link, "_blank");
    }

    const currentList = this.state.list;
    // setReadMsg
    API.setMsgRead({ msgid: currentList[index].messageid }).then(res => {
      // console.log(res);
    });
    currentList.splice(index, 1);
    // 没有数据关闭小窗
    if (currentList.length === 0) {
      this.setState({ visible: false });
    } else {
      this.setState({ list: currentList });
    }
  };

  onTitleIconClick = () => {
    const numDom = $(
      `#dialogMode-message-center-${this.props.id} .right-corner-num`
    );
    const listLength = this.state.list.length;
    const value = Number(numDom.text()) - listLength;
    if (value > 0) {
      numDom.text(value);
    } else {
      numDom.hide();
    }
    API.setMsgRead({
      msgid: this.state.list.map(item => item.messageid).join()
    });
    this.setState({
      visible: !this.state.visible,
      list: [],
      index: 0,
      msgid: ""
    });
  };

  afterChange = index => {
    this.setState({ index });
  };

  onAItemClick = (e, item, index) => {
    e.stopPropagation();
    this.clickTitle(index, item);
  };

  showSystemSet = () => {
    this.setState({
      systemSetVisiable: true
    });
  };

  hideSystemSet = () => {
    this.setState({
      systemSetVisiable: false
    });
  };

  doMore = () => {
    $(`#dialogMode-message-center-${this.props.id}`).click();
  };

  render() {
    const title = this.state.list.filter((item, index) => {
      return index === this.state.index;
    });
    return (
      <div
        id={`pop-close-${this.props.id}`}
        style={this.state.visible ? { display: "block" } : { display: "none" }}
        className={"wea-messageCenter-fixedPop"}
      >
        <this.state.syncComponent />
        <div className="wea-messageCenter-bodyContainer">
          <div className="wea-messageCenter-bodyTitle">
            {title[0] && title[0].name}
            <Icon
              onClick={this.onTitleIconClick}
              className="wea-messageCenter-bodyTitleIcon"
              type="cross"
            />
          </div>
          <div className="wea-messageCenter-bodyCarousel">
            {this.state.list.length > 0 && (
              <Carousel
                dots={this.state.list.length > 1}
                afterChange={this.afterChange}
              >
                {this.state.list.map((item, index) => (
                  <div>
                    <Card
                      bordered={false}
                      className="wea-messageCenter-bodyCarouselItem"
                    >
                      <ItemTitle
                        item={item}
                        index={index}
                        onAItemClick={this.onAItemClick}
                      />
                      <div className="content">
                        {desensitization(item.context) ||
                        encryption(item.context) ? (
                          <Encry value={item.context} />
                        ) : (
                          <p
                            dangerouslySetInnerHTML={{
                              __html:
                                item.context &&
                                item.context.replace(/<img[^>]+>/gi, "[图片]")
                            }}
                          />
                        )}
                      </div>
                    </Card>
                  </div>
                ))}
              </Carousel>
            )}
            <div
              style={{ width: "100px" }}
              className="corner-set wea-f12"
              onClick={this.showSystemSet}
            >
              <i className="icon-coms-Flow-setting" /> &ensp;
              {getLabel("21946", "提醒设置")}
            </div>
            <span className="more-link">
              <a
                className="wea-f12"
                onClick={this.doMore}
                href="javascript: void(0);"
              >
                {getLabel("17499", "更多")}
              </a>
            </span>
            <SystemSet
              // systemSetStore={this.props.systemSetStore}
              systemSetStore={WeaMessageCenterStore}
              visible={this.state.systemSetVisiable}
              onCancel={this.hideSystemSet}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/fixedPop.js